/**
 * @typedef {Object} InitProfileEditorUser_User_Type
 * @property {string} userId
 * @property {string} contactId
 * @property {string} vFileId
 * @property {boolean} isEnabled
 * @property {string} firstName
 * @property {string} lastName
 * @property {string} username
 * @property {string} phoneWork
 * @property {string} phoneWorkDialCode
 * @property {string} phoneWorkCountryCode
 * @property {string} phoneWorkExt
 * @property {string} phoneMobile
 * @property {string} phoneMobileDialCode
 * @property {string} phoneMobileCountryCode
 * @property {string} phoneMobileExt
 * @property {string} phoneOther
 * @property {string} phoneOtherDialCode
 * @property {string} phoneOtherCountryCode
 * @property {string} phoneOtherExt
 * @property {string} emailWork
 * @property {string} emailPersonal
 * @property {string} emailOther
 * @property {Object[]} userLanguages
 * @property {string} userLanguages.id
 * @property {string} userLanguages.code
 * @property {string} userLanguages.name
 * @property {Object[]} userContactTypes
 * @property {string} userContactTypes.Id
 * @property {string} userContactTypes.Title
 * @property {Object[]} userRoleGroups
 * @property {string} userRoleGroups.id
 * @property {string} userRoleGroups.name
 * @property {string} userRoleGroups.appId
 * @property {Object[]} userCompanies
 * @property {string} userCompanies.RowNumber
 * @property {string} userCompanies.Id
 * @property {string} userCompanies.Name
 * @property {Object} userAccessible
 * @property {string} userAccessible.RowNumber
 * @property {string} userAccessible.Id
 * @property {string} userAccessible.Name
 * @property {Object[]} userAddresses
 * @property {string} userAddresses.address_id
 * @property {string} userAddresses.type
 * @property {string} userAddresses.street
 * @property {string} userAddresses.city
 * @property {string} userAddresses.province
 * @property {string} userAddresses.country
 * @property {string} userAddresses.postalCode
 * @property {string} userAddresses.placeId
 * @property {string} userAddresses.lat
 * @property {string} userAddresses.lng
 * @property {string} userAddresses.unit
 * @property {string} notes
 * @property {string} image
 * @property {string} password
 * @property {string} confirmPassword
 * @property {*} file
 * @type {InitProfileEditorUser_User_Type}
 */
export const initProfileEditorUser = {
	userId: '',
	contactId: '',
	vFileId: '',
	isEnabled: false,
	firstName: '',
	lastName: '',
	username: '',
	phoneWork: '',
	phoneWorkDialCode: '',
	phoneWorkCountryCode: '',
	phoneWorkExt: '',
	phoneMobile: '',
	phoneMobileDialCode: '',
	phoneMobileCountryCode: '',
	phoneMobileExt: '',
	phoneOther: '',
	phoneOtherDialCode: '',
	phoneOtherCountryCode: '',
	phoneOtherExt: '',
	emailWork: '',
	emailPersonal: '',
	emailOther: '',
	userLanguages: [],
	userContactTypes: [],
	userRoleGroups: [],
	userCompanies: [],
	userAccessible: {},
	userAddresses: [],
	notes: '',
	image: '',
	password: '',
	confirmPassword: '',
	file: null,
};

/**
 * @typedef {Object} InitProfileEditorUser_Valid_Type
 * @property {string} firstName
 * @property {string} lastName
 * @property {string} username
 * @property {string} phoneWork
 * @property {string} phoneMobile
 * @property {string} phoneOther
 * @property {string} emailWork
 * @property {string} emailPersonal
 * @property {string} emailOther
 * @property {Object[]} userLanguages
 * @property {Object[]} userContactTypes
 * @property {Object[]} userRoleGroups
 * @property {Object[]} userCompanies
 * @property {Object} userAccessible
 * @property {string} password
 * @property {string} confirmPassword
 * @type {InitProfileEditorUser_Valid_Type}
 */
export const initProfileEditorValid = {
	firstName: { hasErr: false, msg: '', canNotSave: false },
	lastName: { hasErr: false, msg: '', canNotSave: false },
	username: { hasErr: false, msg: '', canNotSave: false },
	phoneWork: { hasErr: false, msg: '', canNotSave: false },
	phoneMobile: { hasErr: false, msg: '', canNotSave: false },
	phoneOther: { hasErr: false, msg: '', canNotSave: false },
	emailWork: { hasErr: false, msg: '', canNotSave: false },
	emailPersonal: { hasErr: false, msg: '', canNotSave: false },
	emailOther: { hasErr: false, msg: '', canNotSave: false },
	userLanguages: { hasErr: false, msg: '', canNotSave: false },
	userContactTypes: { hasErr: false, msg: '', canNotSave: false },
	userRoleGroups: { hasErr: false, msg: '', canNotSave: false },
	userCompanies: { hasErr: false, msg: '', canNotSave: false },
	userAccessible: { hasErr: false, msg: '', canNotSave: false },
	password: { hasErr: false, msg: '', canNotSave: false },
	confirmPassword: { hasErr: false, msg: '', canNotSave: false },
};
